exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.date-select > span {\n  width: 100% !important;\n  text-align: center !important;\n}\n\n#smartwizard {\n  margin-top:30px;\n}\n.enterPhoneNumberToRegister\n{\n  padding-top: 25px;\n  text-align: center;\n  font-size: 12px;\n  color: #8b8b8b;\n}\n\n@media(max-width:400px)\n{\n  /*#smartwizard {*/\n    /*width: 95vw;*/\n  /*}*/\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/register/register.style.css
// module id = 990
// module chunks = 3